<template lang="pug">
  footer#footer.lr-footer
</template>

<script>
export default {
  name: 'lr-footer',
}
</script>
